import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../../api.js';
import { useAuth } from '../../auth.jsx';
import { useI18n } from '../../i18n/index.jsx';
import { Alert, Field, PasswordInput } from '../../components/ui.jsx';
import AuthLayout from '../../components/auth/AuthLayout.jsx';
import GoogleButton from '../../components/auth/GoogleButton.jsx';
import { afterSignIn } from './postLogin.js';

export default function Login() {
  const { t, errorText } = useI18n();
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const finish = ({ token, user }) => {
    signIn(token, user);
    navigate(afterSignIn(user, next), { replace: true });
  };

  async function submit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      finish(await api('/auth/login', { method: 'POST', body: { email, password } }));
    } catch (err) {
      setError(errorText(err));
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      titleKey="auth.signinTitle"
      title={t('auth.signinTitle')}
      lead={t('auth.signinLead')}
      below={<>{t('auth.newHere')} <Link to={`/signup${next ? `?next=${encodeURIComponent(next)}` : ''}`}>{t('auth.createAccount')}</Link></>}
    >
      <form onSubmit={submit} className="form">
        <Field label={t('auth.email')} htmlFor="li-email">
          <input id="li-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
        </Field>
        <Field label={t('auth.password')} htmlFor="li-password">
          <PasswordInput id="li-password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        </Field>
        <p className="form-aside"><Link to="/forgot-password">{t('auth.forgotLink')}</Link></p>
        <Alert>{error}</Alert>
        <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={busy}>
          {busy ? t('common.loading') : t('auth.continue')}
        </button>
      </form>
      <GoogleButton text="signin_with" divider="before" onSignedIn={finish} />
    </AuthLayout>
  );
}
